import { Calculator, ExternalLink } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function AdminAccounting() {
  return (
    <div className="space-y-6" data-testid="admin-accounting">
      <h1 className="text-2xl font-bold text-white">Бухгалтерия</h1>
      <div className="bg-slate-800 border border-slate-700 rounded-lg p-8 text-center">
        <Calculator className="h-10 w-10 text-slate-500 mx-auto mb-4" />
        <p className="text-slate-300 font-medium mb-2">Внешняя бухгалтерская система</p>
        <p className="text-slate-500 text-sm max-w-lg mx-auto mb-6">Как и в оригинальном проекте, это ссылка на внешнюю систему учёта — интеграция данных не реализована.</p>
        <Button asChild className="bg-blue-600 hover:bg-blue-700 text-white gap-2"><a href="https://www.fiken.no" target="_blank" rel="noreferrer">Открыть бухгалтерию<ExternalLink className="h-4 w-4" /></a></Button>
      </div>
    </div>
  );
}
